<template>
  <div class="affix-box" :style="{top : top}">
    <img src="@/assets/customer-service-icon.png" />
    <div class="customer-service-way-box">
      <div v-for="item in list" :key="item.label" @click="handleClick(item)" :style="{cursor: (item.label == 'telegram' ? 'pointer' :'default')}">
        <Poptip trigger="hover" transfer placement="left">
          <div class="way">
            <img :src="require('@/assets/' + item.img + '-icon.png')" />
            <span>{{ item.label }}</span>
          </div>
          <template #content>
            <img
              class="des-img-box"
              :src="require('@/assets/' + item.des + '.png')"
            />
          </template>
        </Poptip>
      </div>
      <div @click.stop="freeTest" class="test-box">免费测试</div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        innerHeight:Number
    },
    watch: {
        innerHeight(){
            this.resetTop();
        }
    },
  data() {
    return {
      list: [
        {
          label: "telegram",
          img: "telegram",
          des: "telegram",
        },
        {
          label: "whatsapp",
          img: "phone",
          des: "whatapp",
        },
        {
          label: "微信",
          img: "wx",
          des: "qrCode",
        },
      ],
      top: ((((window.innerHeight - 200) / 2) - 100) + "px")
    };
  },
    created(){
        this.resetTop();
    },
methods: {
    resetTop(){
        if(this.iid){
            return;
        }
        this.iid = setTimeout(() => {
            this.top = (((this.innerHeight - 200) / 2) - 100) + "px"
            this.iid = 0;
        }, 300);

    },
    freeTest() {
      this.$emit("on-free-test");
    },
    handleClick(item) {
      if (item.label == "telegram") {
        window.open("https://t.me/yifanyi", "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.affix-box {
    transition: 0.2s;
  position: fixed;
  z-index: 9;
  right: 16px;
  top: 500px;
  img {
    width: 118px;
    height: 118px;
  }
  .customer-service-way-box {
    font-size: 19px;
    font-weight: 600;
    color: #2e3742;
    background: url("../../assets/customer-service-bg.png");
    background-size: 100% 100%;
    width: 243px;
    height: 295px;
    padding: 70px 36px 47px 50px;
    position: absolute;
    left: -144px;
    top: 34px;
    z-index: -1;
    .way {
      display: flex;
      align-items: center;
      margin-top: 12px;
      img {
        width: 43px;
        height: 43px;
        border-radius: 50%;
        margin-right: 16px;
      }
    }
    .test-box {
      cursor: pointer;
      text-align: center;
      width: 100%;
      background: linear-gradient(90deg, #178cff 0%, #006fff 100%);
      box-shadow: 0px 6px 16px 0px rgba(0, 98, 255, 0.41),
        inset 0px -2px 0px 0px rgba(0, 48, 142, 0.22);
      border-radius: 21px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      padding: 5px 0 9px 0;
      justify-content: center;
      margin-top: 30px;
    }
    /deep/.ivu-poptip-title {
      display: none;
    }
  }
}
.des-img-box {
  width: 100px;
  height: 100px;
}
</style>